var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 16.5",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "28f4762b39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.308594 0 L 36.691406 0 L 36.691406 15.707031 L 0.308594 15.707031 Z M 0.308594 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4a61950135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.558594 4.855469 L 31 4.855469 L 31 12 L 7.558594 12 Z M 7.558594 4.855469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e43adcf498"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31 10 L 32.308594 10 L 32.308594 12.136719 L 31 12.136719 Z M 31 10 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#28f4762b39)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M 0.308594 0 L 36.695312 0 L 36.695312 15.707031 L 0.308594 15.707031 Z M 0.308594 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4a61950135)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d25525",
    d: "M 8.851562 11.257812 C 9.179688 11.257812 9.503906 11.113281 9.726562 10.835938 C 11.566406 8.53125 15.042969 7.101562 18.800781 7.101562 C 21.59375 7.101562 24.230469 7.898438 26.164062 9.246094 L 24.84375 9.28125 C 24.226562 9.300781 23.738281 9.8125 23.753906 10.4375 C 23.769531 11.042969 24.269531 11.523438 24.875 11.523438 C 24.886719 11.523438 24.894531 11.523438 24.90625 11.523438 L 28.949219 11.414062 C 29.566406 11.398438 30.054688 10.886719 30.035156 10.261719 L 29.929688 6.21875 C 29.914062 5.601562 29.394531 5.136719 28.777344 5.132812 C 28.160156 5.148438 27.671875 5.664062 27.6875 6.285156 L 27.726562 7.617188 C 25.394531 5.867188 22.226562 4.867188 18.800781 4.867188 C 14.3125 4.867188 10.261719 6.578125 7.972656 9.445312 C 7.589844 9.925781 7.664062 10.636719 8.152344 11.019531 C 8.359375 11.175781 8.601562 11.257812 8.851562 11.257812 Z M 8.851562 11.257812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e43adcf498)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d25525",
    d: "M 31.929688 15.214844 C 31.929688 17.832031 34.050781 19.960938 36.675781 19.960938 C 39.296875 19.960938 41.421875 17.832031 41.421875 15.214844 C 41.421875 12.59375 39.296875 10.46875 36.675781 10.46875 C 34.058594 10.46875 31.929688 12.59375 31.929688 15.214844 Z M 31.929688 15.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a76157d171237a3aa8a68567ea398439.svg";
export { ForwardRef as ReactComponent };